module.exports = __webpack_public_path__ + "static/media/gold.eaa49eae.png";